import { GrowthBook } from '@growthbook/growthbook-react';
import { logger } from 'logger';

export const FeatureKeys = {
  ShowPdpVouchers: 'show_pdp_vouchers',
} as const;

export type AppFeatures = {
  [FeatureKeys.ShowPdpVouchers]: boolean;
};

export const growthbook = new GrowthBook<AppFeatures>({
  apiHost: process.env.GROWTHBOOK_API_HOST || 'https://cdn.growthbook.io',
  clientKey: process.env.GROWTHBOOK_CLIENT_KEY || '',
  enableDevMode: process.env.APP_ENV !== 'production',
  attributes: {
    platform: 'web',
  },
});

export const initGrowthBook = async () => {
  if (!process.env.GROWTHBOOK_CLIENT_KEY) {
    return;
  }

  try {
    await growthbook.init({ streaming: true });
  } catch (error) {
    if (process.env.APP_ENV !== 'production') {
      logger.warn('GrowthBook init failed', error);
    }
  }
};
